import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { CompteService } from '@service/syndic/compte.service';
import { Globals } from '@theme/utils/globals';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CompteAddComponent } from '../compte-add/compte-add.component';

@Component({
  selector: 'app-compte-list',
  templateUrl: './compte-list.component.html',
  styleUrls: ['./compte-list.component.scss']
})
export class CompteListComponent implements OnInit {
  @Input() comptes: any[] = [];
  @Input() trusteeUuid: string = '';
  dtOptions: any = {};

  constructor(
    private modalService: NgbModal,
    private emitter: EmitterService,
    private compteService: CompteService
  ) {
    this.emitter.event.subscribe((data: any) => {
      if (data.action === 'COMPTE_ADD' || data.action === 'COMPTE_UPDATED') {
        this.loadData();
      }
    });
  }

  ngOnInit(): void {
    this.dtOptions = Globals.dataTable;
    this.loadData();
  }

  loadData(): void {
    if (this.trusteeUuid) {
      this.compteService.getList(this.trusteeUuid).subscribe((res: any) => {
        this.comptes = res || [];
      });
    }
  }

  addCompte(): void {
    this.compteService.edit = false;
    this.compteService.setCompte(null);
    this.modal(CompteAddComponent, 'modal-basic-title', 'lg');
  }

  editCompte(row: any): void {
    this.compteService.edit = true;
    this.compteService.setCompte(row);
    this.modal(CompteAddComponent, 'modal-basic-title', 'lg');
  }

  deleteCompte(item: any): void {
    Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: 'Cette action est irréversible !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Non, annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.compteService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.status === 'success') {
            this.loadData();
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        });
      }
    });
  }

  modal(component: any, type: string, size: string): void {
    const modalRef = this.modalService.open(component, {
      ariaLabelledBy: type, size: size, centered: true, backdrop: 'static'
    });
    modalRef.result.then((result) => {}, (reason) => {});
  }
}
